import {
  getAllFechamento,
  getFechamentoAtual,
  FechamentoResult,
  solicitarGeracaoDoRelatorioFechamento,
} from '@app/api/fechamento';
import { getAllRelatorioExecucaoRotina } from '@app/api/parametro';
import { hasPermission } from '@app/helpers/permissions';
import {
  Button,
  FormatText,
  FormInput,
  FormSubmitButton,
  GridView,
  MasterDetailForm,
  SimpleView,
  Table,
  Widget,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import React, { useState, useEffect } from 'react';
const { Panel } = Collapse;
import { PaginationConfig } from 'antd/lib/pagination';
import { solicitacaoExecucaoRotinaRelatorioProjetoPacote, solicitarAtualizacaoRelatorioADistribuirRelatorio } from '@app/api/routines';
import TableExecucaoRotina from '../Configuracao/TableExecucaoRotina';
import { useSetRecoilState } from 'recoil';
import { listHistoricoExecucaorotina } from '@app/state/atom';

const colums = () => {
  return [
    {
      title: 'N',
      dataIndex: 'index',
      with: '2%',
    },
    {
      title: 'Mês/Ano',
      dataIndex: 'mesAno',
      with: '68%',
      render: (text, record, index) => {
        return <> {record.mes + '/' + record.ano} </>;
      },
    },
    {
      title: 'Data execução',
      dataIndex: 'createdAtFormatado',
      with: '10%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      with: '10%',
    },
  ];
};

const RotinaFechamento = () => {

  const [dataMesANo, setMesAno] = useState('');
  const [allFechamento, setAllFechamento] = useState<FechamentoResult[]>([]);
  const setHistoricosRotinas = useSetRecoilState(listHistoricoExecucaorotina);


  const getAll = async () => {
    const result = await getAllFechamento();
    if (result) {
      setAllFechamento(result);
    }
  };



  useEffect(() => {
    getFechamentoAtual().then(dataAtual => {
      if (dataAtual) {
        setMesAno(dataAtual);
      }
    });
    getAll();
  }, []);



  const hasSolicitarGeracaoDoRelatorioFechamento = () => {
    solicitarGeracaoDoRelatorioFechamento();
  };

  const solicitarCriacaoProjetoPacote = () => {
    solicitacaoExecucaoRotinaRelatorioProjetoPacote();
  }

  useEffect(() => {
    getHistoricoData();
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      getHistoricoData();
    }, 60000)
    return () => clearInterval(intervalId);
  }, [useState]);

  const getHistoricoData = async () => {
    const result = await getAllRelatorioExecucaoRotina();
    if (result) {
      const resultadoRotina = result.filter(rotina => rotina.responsavel === 'Rotina');
      if (resultadoRotina) {
        resultadoRotina.forEach((historico, index) => {
          historico.index = index + 1;
        });
      }
      setHistoricosRotinas(resultadoRotina);
    }
  };

  return (
    <SimpleView>
      <GridView noform>


        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="1" header="SOLICITAR CRIAÇÃO DO FECHAMENTO" style={{ border: 0 }}>
            <MasterDetailForm
              initialValues={dataMesANo}
              onSubmit={values => {
                hasSolicitarGeracaoDoRelatorioFechamento();
              }}>
              <Widget
                actions={[
                  hasPermission(['SOLICITAR_CRIACAO_FECHAMENTO']) && (
                    <FormSubmitButton type="primary">
                      <FormatText id="ui.commons.save" uppercase />
                    </FormSubmitButton>
                  ),
                ]}>
                <FormInput label="Mes/Ano" name="mesAno" span={2} disabled={true} />
              </Widget>
            </MasterDetailForm>
          </Panel>
        </Collapse>

        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="2" header="RESUMO FECHAMENTO" style={{ border: 0 }}>
            <Widget>
              <Table
                columns={colums()}
                dataSource={allFechamento}
                pagination={
                  {
                    pageSize: 5,
                  } as PaginationConfig}
              />

            </Widget>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={['3']} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
          <Panel key="3" header="Relatório das rotinas do sistema" style={{ border: 0 }}>
            <Widget actions={
              [
                <Button
                  type="primary"
                  size={'small'}
                  icon="business-request_service"
                  onClick={() => {
                    solicitarCriacaoProjetoPacote()
                  }}
                >
                  Solicitar criação do relatório PROJETO PACOTE
                </Button>,
                <Button
                  type="primary"
                  size={'small'}
                  icon="business-request_service"
                  onClick={() => {
                    solicitarAtualizacaoRelatorioADistribuirRelatorio()
                  }}
                >
                  Atualizando Relatório Verificação de Erros
                </Button>
              ]}>
              <TableExecucaoRotina />
            </Widget>
          </Panel>
        </Collapse>

      </GridView>
    </SimpleView>
  );
};

export default RotinaFechamento;
